const en = {
  general: {
    name: 'HongGuang',
    login: 'login',
    zh: 'T. Chinese',
    en: 'English',
    cn: 'S. Chinese',
    preview: 'Preview',
    upload_document_file: 'Upload .pdf, .doc and .docx file',
    select_image: 'Select Image',
    image: 'Image',
    year: 'Year',
    cancel: 'Cancel',
    ok: 'OK',
    add: 'Add',
    confirm: 'Confirm',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    document: 'document',
    title: 'Title',
    content: 'Content',
  },
  navigation: {
    home: 'Home',
    media_coverage: 'Media Coverage',
    press_release: 'Press Release',
    jobs: 'Job | Jobs',
    announcement: 'Announcement',
    report: 'Report',
    presentation: 'Presentation',
    analyst_coverage: 'Analyst Coverage',
    enquiry: 'Enquiry',
    investor_notices: 'Investor Relations Notices',
  },
  home: {
    banner: 'Banner',
    upload_new_banner: 'Upload New Banner',
    slogan_title: 'Slogan Title',
    slogan_subtitle: 'Slogan Subtitle',
    slogan_description: 'Slogan Description',
  },
  media_coverage: {
    new_media_coverage: 'New Media Coverage',
    edit_media_coverage: 'Edit Media Coverage',
  },
  jobs: {
    new_job: 'New Job',
    edit_job: 'Edit Job',
    requirement: 'Requirement',
    job_title: 'Job Title',
    publish_date: 'Publish date',
  },
  announcements: {
    new_announcement: 'New Announcement',
    edit_announcement: 'Edit Announcement',
    select_year: 'Select Year',
    publish_date: 'Publish date',
    document_title: 'Document title',
    upload_document: 'Upload document',
  },
  reports: {
    new_report: 'New Report',
    edit_report: 'Edit Report',
    select_year: 'Select Year',
    publish_date: 'Publish date',
    document_title: 'Document title',
    upload_document: 'Upload document',
  },
  media_coverage: {
    new_media_coverage: 'New Media Coverage',
    edit_media_coverage: 'Edit Media Coverage',
    publish_date: 'Publish date',
    category: 'Category',
    consumer_electronics: 'Consumer Electronics',
    automotive_electronics: 'Automotive Electronics',
    data_centers: 'Data Centers',
    renewable_energy: 'Renewable Energy',
    industrial: 'Industrial',
  },
  press_release: {
    new_press_release: 'New Press Release',
    edit_press_release: 'Edit Press Release',
    publish_date: 'Publish date',
  },
  presentation: {
    new_presentation: 'New Presentation',
    edit_presentation: 'Edit Presentation',
    select_year: 'Select Year',
    publish_date: 'Publish date',
    document_title: 'Document title',
    upload_document: 'Upload document',
  },
  analyst_coverage: {
    new_analyst_coverage: 'New Analyst Coverage',
    edit_analyst_coverage: 'Edit Analyst Coverage',
    company: 'Company',
    analyst: 'Analyst',
    email: 'Email',
  },
  enquiry: {
    name: 'Name',
    organisation: 'Organisation',
    email: 'Email',
    telephone: 'Telephone',
    message: 'Message',
  },
  investor_notices: {
    new_notices: 'New Notice',
    edit_notices: 'Edit Notice',
    publish_date: 'Publish date',
    document_title: 'Document title',
    upload_document: 'Upload document',
  },
  instruction: {
    create_success: 'Create Success',
    create_fail: 'Create Fail',
    update_success: 'Update Success',
    update_fail: 'Update Fail',
    remove_success: 'Remove Success',
    remove_fail: 'Remove Fail',
    upload_success: 'Upload Success',
    upload_fail: 'Upload Fail',
    update_not_required: 'Updated is not required',
    remove_item: 'Do you want to remove this',
    data_not_found: 'Data not Found',
  },
  error: {
    force_input: 'Please input the',
    force_select: 'Please select the',
    force_upload: 'Please upload the',
  },
}

export default en
